import { EntityActionNames, IEntityAction } from '../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { isSingleDatasourceWithExtract, isSingleEmbeddedDatasource } from '../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { Messages } from '../codegen/Localize';
import { FeatureFlags } from '../ts/FeatureFlags';
import { IContentInfo } from '../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../ts/ServerApi/types/actionNames';
import { newMetricForDatasource } from './actions/NewMetricForDatasourceAction';

export const NewMetricEntityAction: IEntityAction<IContentInfo<'datasource'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.NewMetric,
  translateName: Messages.newMetric,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.metricsAuthoringPathEnabled && !isSingleEmbeddedDatasource(targetItems) && isSingleDatasourceWithExtract(targetItems);
  },
  isClickable: (availableActions: ILaunchWebAuthoringAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.launchWebAuthoring,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newMetricForDatasource(item);
    }
  }
};
